<template>
  <div class="h-100">
    <router-view />

    <CookieNotice />
  </div>
</template>

<script>
import apiMixin from './utils/api'
import CookieNotice from "./components/CookieNotice"

export default {
  name: 'App',
  components: {CookieNotice},
  mixins: [apiMixin],
  async created() {
    await this.$store.dispatch('user/getDetails', this)
  }
}
</script>
